import { render, staticRenderFns } from "./messageTemp-list.vue?vue&type=template&id=ea410cde&scoped=true"
import script from "./messageTemp-list.vue?vue&type=script&lang=ts"
export * from "./messageTemp-list.vue?vue&type=script&lang=ts"
import style0 from "./messageTemp-list.vue?vue&type=style&index=0&id=ea410cde&prod&lang=scss&scoped=true"
import style1 from "./messageTemp-list.vue?vue&type=style&index=1&id=ea410cde&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ea410cde",
  null
  
)

export default component.exports